<script lang="ts">
    import { _ } from "svelte-i18n"
    import Select from "svelte-select/Select.svelte"
    import { selectTouchFix } from "../../../lib/actions/selectTouchFix"

    let { value = $bindable() } = $props()
    const selectableFonts = [
        {
            label: $_("cart.segoe"),
            description: "ABCDEabcde12345",
            value: "segoe",
        },
        {
            label: $_("cart.din1451"),
            description: "ABCDEabcde12345",
            value: "din1451",
        },
        {
            label: $_("cart.trebuchet"),
            description: "ABCDEabcde12345",
            value: "trebuchet",
        },
    ]
    let selectedFont = $state(
        value ? selectableFonts.find((el) => el.value == value) || selectableFonts[0] : selectableFonts[0]
    )

    $effect(() => {
        value = selectedFont.value
    })
</script>

<div class="font-select" use:selectTouchFix>
    <Select bind:value={selectedFont} items={selectableFonts} clearable={false} showChevron={true}>
        <div slot="item" let:item class="selection {item.value}">
            <div class="label">
                {item.label}
            </div>
            <div class="description">
                {item.description}
            </div>
        </div>
        <div slot="selection" let:selection class="selection {selection.value}">
            <div class="label">
                {selection.label}
            </div>
            <div class="description">
                {selection.description}
            </div>
        </div>
    </Select>

    {#if false}
        <div class="svelte-select"></div>
    {/if}
</div>

<style global>
    .font-select {
        :global(div.selected-item) {
            width: 100% !important;
            min-width: 100%;
            margin: 0px;
            padding-left: 0px;
            cursor: pointer !important;
            padding-right: 0px !important;
        }
        :global(.svelte-select) {
            border-radius: 0px !important;
            border: 0px solid black !important;
            border-bottom: 1px solid var(--red-100) !important;
            background-color: transparent !important;
            padding: 0px;
            cursor: pointer !important;
            position: relative;
            :global(.list-item .item) {
                height: unset !important;
                cursor: pointer !important;
                background-color: var(--white-100) !important;
                padding: 0.6rem !important;
                color: var(--on-background) !important;
                * {
                    color: var(--on-background) !important;
                }
            }
            :global(.indicators) {
                align-items: flex-end;
                padding-bottom: 0.5rem;
                cursor: pointer !important;
                color: var(--grey-400) !important;
            }
            :global(.indicators .icon) {
                border-left: 0px !important;
                cursor: pointer !important;
            }
        }
        .selection {
            display: flex;
            flex-direction: column;
            gap: 0.3rem;
            width: 100%;
            cursor: pointer !important;
            .label {
                color: var(--grey-400);
                font-size: 0.8rem;
                font-style: normal;
                font-weight: 300;
                line-height: normal;
            }
            .description {
                display: flex;
                padding: 0px 0.6rem;
                width: 100%;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                font-size: 1.4rem;
                border: 1px solid var(--grey-200, #e7e7e7);
                background: var(--white-100, #fff);
            }
        }
    }
</style>
